<template>
  <div class="ModalEditor">
    <MapModal
      :modalNode="modalNode"
      :title="ModelNase.title"
      :id="ModelNase.id"
      :close="plotItem_click"
    >
      <template slot="content">
        <div class="content">
          <el-form ref="form" :model="form" class="settings" label-width="80px">
            <el-form-item label="名称：" prop="name" v-if="editModelShow">
              <el-input v-model="viewpointForm.name"></el-input>
            </el-form-item>
            <el-form-item label="比例：">
              <!-- <el-input-number
                v-model="form.scale"
                @change="setStyle"
                controls-position="right"
                size="small"
                :min="0"
                :max="10"
              ></el-input-number> -->
              <el-input-number
                v-model="scale"
                @change="setStyle(true)"
                :min="0"
                :max="10"
                :step="1"
              ></el-input-number>
            </el-form-item>
            <el-form-item label="方向角：">
              <el-slider
                v-model="form.heading"
                :min="0"
                :max="360"
                style="width: 100px"
                @input="setStyle"
              ></el-slider>
            </el-form-item>
            <el-form-item label="俯仰角：">
              <el-slider
                v-model="form.pitch"
                :min="0"
                :max="360"
                @input="setStyle"
                style="width: 100px"
              ></el-slider>
            </el-form-item>
            <el-form-item label="翻滚角：">
              <el-slider
                v-model="form.roll"
                :min="0"
                :max="360"
                @input="setStyle"
                style="width: 100px"
              ></el-slider>
            </el-form-item>
            <!-- <el-form-item label="最小像素大小：">
              <el-input-number
                v-model="form.minimumPixelSize"
                @change="setStyle"
                controls-position="right"
                size="small"
                :min="0"
                style="width: 100px"
              ></el-input-number>
            </el-form-item> -->
            <el-form-item label="透明度：">
              <el-slider
                v-model="form.opacity"
                :format-tooltip="formatTooltip"
                @input="setStyle"
                style="width: 100px"
              ></el-slider>
            </el-form-item>
            <el-form-item label="轮廓：">
              <el-switch v-model="form.silhouette" @change="setStyle">
              </el-switch>
            </el-form-item>

            <!-- <el-form-item label="动画：">
              <el-switch v-model="form.runAnimations" @change="setStyle">
              </el-switch>
            </el-form-item>
            <el-form-item label="阴影：">
              <el-switch v-model="form.hasShadows" @change="setStyle">
              </el-switch>
            </el-form-item> -->
            <el-form-item label="贴地：">
              <el-switch v-model="form.clampToGround" @change="setStyle">
              </el-switch>
            </el-form-item>
          </el-form>
        </div>
      </template>
      <!-- <el-form-item label="按视距显示：">
              <el-switch v-model="form.distanceDisplayCondition"> </el-switch>
            </el-form-item> -->

      <!-- 取消和保存按钮 -->
      <template slot="foot">
        <div class="foot-operate" v-if="this.$parent.$parent.$parent.batchData">
          <el-button type="primary" @click="lastStep">
            上一步
          </el-button>
          <el-button type="primary" @click="StartCreating">
            开始创建
          </el-button>
        </div>
        <div v-else class="foot-operate">
          <el-button @click="escDispose">
            取消
          </el-button>
          <el-button type="primary" @click="onSubmit">
            保存
          </el-button>
        </div>
      </template>
    </MapModal>
  </div>
</template>

<script>
import * as ModelNaseWork from "./ModelNase";

const MapModal = () => import("@/components/common/mapModal/Index");
export default {
  data() {
    return {
      ModelNase: {
        title: "属性编辑",
        id: "ModalEditor",
      },
      modalNode: {
        ModelNase: {
          show: true,
          loading: false,
          // 样式配置 定位使用
          // style: "margin: 106px 0 0 -706px;",
          offset: {
            // 默认弹出层偏移
            // x: 106,
            // y: -376,
            x: 55,
            y: -300,
            // unit: "px", // 默认px
          },
          width: "250px",
          // auto 自适应
          height: `${document.querySelector(".cesium-widget").offsetHeight -
            450}px`, // 配置模态框中心高度
          // height: `${document.querySelector(".cesium-widget").offsetHeight -
          //   30}px`, // 配置模态框中心高度
          //模态框head配置
          head: {
            //是否能拖动
            canmove: {
              //当前拖动状态
              state: false,
            },
            //折叠配置
            fold: {
              //当前折叠状态
              state: true,
            },
          },
        },
      },
      graphics: ModelNaseWork.graphics,
      scale: 1,
      form: {
        scale: 1,
        heading: 0,
        pitch: 0,
        roll: 0,
        opacity: 100,
        clampToGround: false,
        silhouette: false,
        // minimumPixelSize: 10,
        // runAnimations: false,
        // hasShadows: false,
        // classificationType: Cesium.ClassificationType.CESIUM_3D_TILE,
      },
      editModelShow: false,
      viewpointForm: {
        name: "",
      },
    };
  },
  components: { MapModal },
  props: {},
  created() {},
  mounted() {
    this.$eventBus.$on("warehouseModel", (form) => {
      form.graphics.options.style.opacity = 1;
      for (let key in this.form) {
        this.form[key] = form.graphics.options.style[key];
      }
      this.form.opacity = this.form.opacity * 100;

      this.warehouseModel(this.form, form.graphics);
    });

    // ModelNaseWork.bindingEvent();
  },
  methods: {
    warehouseModel(form, graphics) {
      console.log("添加数据");
      this.form = JSON.parse(JSON.stringify(form));
      ModelNaseWork.temporaryData(graphics);
      this.$emit("openEditor");
    },
    plotItem_click() {
      this.$emit("modalEditorClose");
      this.editModelShow = false;
    },
    setStyle(v) {
      if (v) this.form.scale = this.scale;
      let obj = JSON.parse(JSON.stringify(this.form));
      obj.opacity = obj.opacity / 100;

      if (this.editModelShow) {
        this.$emit("set_editModel", obj);
      } else {
        if (this.$parent.$parent.$parent.batchData) {
          ModelNaseWork.setStyleFuns(obj);
        } else {
          ModelNaseWork.setStyleFun(obj);
        }
      }
    },
    deleteGraphic() {
      this.$emit("modalEditorClose");
      ModelNaseWork.deleteGraphic();
    },
    formatTooltip(val) {
      return val / 100;
    },
    onSubmit() {
      if (this.editModelShow) {
        let obj = JSON.parse(JSON.stringify(this.form));
        obj.modelName = this.viewpointForm.name;
        this.$emit("onSubmit", obj);
      } else {
        this.$emit("onSubmit", ModelNaseWork.onSubmit(this.form));
      }
    },
    escDispose() {
      this.modalNode.ModelNase.show = false;
      this.editModelShow = false;
      this.$emit("modalEditorClose");
      ModelNaseWork.deleteAll();
    },
    // generateRandomInteger(min, max) {
    //   return Math.floor(Math.random() * (max - min + 1)) + min;
    // },
    StartCreating() {
      this.$emit("batchCreate", this.form);
    },
    lastStep() {
      this.modalNode.ModelNase.show = false;
      this.$emit("lastStep");
    },
    editModel(e) {
      this.editModelShow = true;
      this.viewpointForm.name = e.name;
      let form = JSON.parse(e.graphic);
      form.style.opacity = form.style.opacity * 100;
      for (let key in form.style) {
        this.form[key] = form.style[key];
      }
      this.scale = this.form.scale;
    },
  },
};
</script>

<style scoped lang="scss" src="./ModalEditor.scss"></style>
